import React from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { actions } from "react-redux-form";
import { SearchPanel } from "../../AppLayout/SearchPanel/SearchPanel";
import { ConfigReportsGrid } from "../configReportsGrid";
import { reportActions } from "../../../../redux/actions";
import { getConfiguredReportsParams } from "../../../../utils";
import "./ConfigReports.css";

class ConfigReports extends React.Component {
  handlePageClick = (event) => {
    const { dispatch, isExternalUser, externalCustomerId, configReportSearch } =
      this.props;
    event.preventDefault();
    var _pageNum = Number(event.target.id);
    if (_pageNum > 0) {
      dispatch(actions.change("configReportSearch.PageNumber", _pageNum));
      dispatch(
        reportActions.getConfiguredReports(
          getConfiguredReportsParams(
            {
              ...configReportSearch,
              PageNumber: _pageNum,
            },
            isExternalUser,
            externalCustomerId
          )
        )
      );
    }
  };

  handlePageReload = () => {
    const { dispatch, isExternalUser, externalCustomerId, configReportSearch } =
      this.props;
    var _pageNum = configReportSearch.PageNumber;
    if (_pageNum > 0) {
      //dispatch(actions.change('configReportSearch.PageNumber', _pageNum));
      dispatch(
        reportActions.getConfiguredReports(
          getConfiguredReportsParams(
            {
              ...configReportSearch,
              PageNumber: _pageNum,
            },
            isExternalUser,
            externalCustomerId
          )
        )
      );
    }
  };
  handleFirstClick = (event) => {
    const { dispatch, isExternalUser, externalCustomerId, configReportSearch } =
      this.props;
    event.preventDefault();
    dispatch(actions.change("configReportSearch.PageNumber", 1));
    dispatch(
      reportActions.getConfiguredReports(
        getConfiguredReportsParams(
          { ...configReportSearch, PageNumber: 1 },
          isExternalUser,
          externalCustomerId
        )
      )
    );
  };
  handleSearchClick = () => {
    const { dispatch, isExternalUser, externalCustomerId } = this.props;
    dispatch(actions.change("configReportSearch.PageNumber", 1));
    dispatch(
      reportActions.getConfiguredReports(
        getConfiguredReportsParams(
          { ...this.props.configReportSearch, PageNumber: 1 },
          isExternalUser,
          externalCustomerId
        )
      )
    );
  };
  handleParamChange = (paramName, paramValue) => {
    this.props.dispatch(
      actions.change(`configReportSearch.${paramName}`, paramValue)
    );
  };

  componentDidMount() {
    const { defaultReportPage, dispatch } = this.props;
    if (defaultReportPage !== "/config-reports") {
      dispatch(reportActions.setDefaultReportPage("/config-reports"));
    }
  }

  render() {
    const { configuredReports, CRTotalPages, configReportSearch } = this.props;
    let PageNumber = configReportSearch.PageNumber;
    let prev = PageNumber > 0 ? PageNumber - 1 : 0;
    let pageNumbers = [];
    // get window of max 5
    let start = PageNumber;
    let last = start + 5;
    if (last > CRTotalPages) {
      last = CRTotalPages;
    }
    for (let i = start; i <= last; i++) {
      pageNumbers.push(i);
    }
    return (
      <div>
        <div className="w-100 top_search" style={{ textAlign: "center" }}>
          <SearchPanel
            view="configReportsView"
            searchParams={configReportSearch}
            isExternalUser={this.props.isExternalUser}
            handleParamChange={this.handleParamChange}
            onSearchClick={(params_) => {
              this.handleSearchClick(params_);
            }}
            //handlePageReload={this.handlePageReload}
          />
        </div>
        <ConfigReportsGrid
          isExternalUser={this.props.isExternalUser}
          reports={configuredReports}
          reportName="configuredReports"
          handlePageClick={this.handlePageClick}
          handleFirstClick={this.handleFirstClick}
          handlePageReload={this.handlePageReload}
          PageNumber={PageNumber}
          prev={prev}
          last={last}
          pageNumbers={pageNumbers}
          showCustomerColumn={true}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    reports: {
      configuredReports,
      CRTotalPages,
      defaultReportPage,
      selectedReportEdit,
      selectedReportEditIsActive,
      selectedReportEditIsInternalUse,
    },
    configReportSearch,
    locale,
    loaderMask,
  } = state;
  return {
    configuredReports,
    CRTotalPages,
    defaultReportPage,
    selectedReportEdit,
    selectedReportEditIsActive,
    selectedReportEditIsInternalUse,
    configReportSearch,
    loaderMask,
    translate: getTranslate(locale),
  };
}

const connectedConfigReports = connect(mapStateToProps)(ConfigReports);
export { connectedConfigReports as ConfigReports };
